import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/t/contracts')({
  staticData: { breadcrumb: 'Contracts', breadcrumbKey: 'K_BREADCRUMB_CONTRACTS' },
  component: ContractsLayout,
});

function ContractsLayout() {
  return <Outlet />;
}
